import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';

const generatePosterUrl = (poster) => {
  const posterUrl = poster?.filename?.replace('https://a.storyblok.com/', '');
  return `https://img2.storyblok.com/filters:quality(50)/${posterUrl}`;
};

const Video = ({ className, poster, video }) => {
  const posterImage = generatePosterUrl(poster);
  const videoUrl = video?.filename;
  const videoRef = useRef(null);
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.setAttribute('muted', '');
    }
  }, []);

  return (
    <video
      className={className}
      src={videoUrl}
      poster={posterImage}
      ref={videoRef}
      autoPlay
      muted
      loop
      playsInline
      disablePictureInPicture
      disableRemotePlayback
    />
  );
};

Video.propTypes = {
  className: PropTypes.string,
  poster: PropTypes.shape({
    filename: PropTypes.string,
  }),
  video: PropTypes.shape({
    filename: PropTypes.string,
  }),
};

export default Video;
